<template lang="pug">
  y-dialog(v-model="showModal" fill-height fluid scrollable persistent transition="fade-transition" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card
      v-card-title.px-5
        v-row(no-gutters)
          v-col
            p.mb-0.title(v-if="option") {{ $t('update_zone') }}
            p.mb-0.title(v-else) {{ $t('add_new_zone') }}
          v-col.shrink
            v-btn.mr-n2(text icon height @click="showModal = !showModal")
              v-icon(:size="24") mdi-close
      v-divider.basic300
      v-card-text.pa-0
        v-form(ref="form")
          v-card.pa-4(flat)
            p.mb-3.label.basic600--text.text-uppercase {{$t('zone.label')}}
            v-text-field(v-model='optionData.name' solo flat outlined dense background-color="basic200" height="40" :placeholder="$t('zone.hint')" :rules="rules.not_empty")
            template(v-if="optionData.id")
              v-btn.button-Aa-small.custom-transform-class.text-none.px-0.mb-2(v-if="company.genes.find(g => g.feature === 'restrict_delivery_area')" color="textColorAccent" text @click="openCityDialog = true" small)
                eva-icon.mt-1.mr-2(name="link-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="14" width="14")
                | {{ $t('restrict_delivery_areas') }}
              p.h6.basic1000--text.mb-4 {{ $t('supported_delivery_method') }}
              .pickup(v-if="Auth('component', '/admin/settings/shipping#self_pickup')")
                y-checkbox.mx-0.mt-0.mb-2.pa-0(v-model="optionData.shipping_methods" hide-details value="pickup")
                  template(v-slot:label)
                    .p1.primary--text {{ $t('delivery_self_pickup') }}

                v-card.px-2.py-4.mt-2.mb-6(v-if="optionData.shipping_methods.includes('pickup')" outlined)
                  .pickup-general(v-if="!storepickup.enabled")
                    v-row(no-gutters)
                      v-col
                        p.mb-3.label.basic600--text.text-uppercase {{ $t('pickup_location_description') }}
                        v-textarea(v-model="optionData.pickup_address" flat outlined auto-grow background-color="basic200" rows="3" :placeholder="$t('pickup_location_placeholder')" :rules="rules.not_empty")
                    v-row.mt-n2(no-gutters)
                      v-col
                        p.mb-0.text-body-2 {{ $t('allow_pay_at_shop') }}
                        p.mb-0.caption.grey--text.text--darken-1 {{ $t('allow_pay_at_shop_text') }}
                      v-col.shrink
                        y-switch.ma-0.pa-0(v-model="pickup.pay_at_shop")
                  .pickup-yezza(v-else)
                    .c1.basic700--text {{ $t('delivery_self_pickup_text') }}
                    v-btn.label.pa-0.mb-n3.mt-n2(color="transparent" text @click="showUpdateStorePickupSettings = true")
                      eva-icon.mt-1.mr-1(name="edit-outline" :fill=" $vuetify.theme.themes[$theme].info500" width="14")
                      div.info500--text {{ $t('manage') }}

              .manual
                y-checkbox.mx-0.mt-0.mb-2.pa-0(v-model="optionData.shipping_methods" value="manual" hide-details)
                  template(v-slot:label)
                    .p1.primary--text {{ $t('manual_delivery') }}
                v-card.pa-0.mt-2.mb-6(v-if="optionData.shipping_methods.includes('manual')" outlined)
                  delivery-charge-list(:company="company" :zone="optionData")
              .others
                template(v-for="(courier, key) in couriers")
                  y-checkbox.mx-0.mt-0.mb-2.pa-0(v-if="courier.enabled" v-model="optionData.shipping_methods" hide-details :key="courier.id" :value="key")
                    template(v-slot:label)
                      .p1.primary--text {{ getCourierName(courier) }}
      v-card-actions.px-4
        v-btn.p1.px-0(v-if="optionData.id && allowDelete" color="red" text @click="openDeleteDialog = true") {{ $t('delete_zone') }}
        v-spacer
        v-btn.button-AA-medium(color="grey" text @click='showModal = false') {{ $t('cancel') }}
        v-btn.button-AA-medium.white--text(depressed color="info500" height="32" :loading="isLoading" @click='clickSave()') {{optionData.id == null ? $t('add_new_zone') : $t('update_zone')}}

      .modal
        zone-city-list(v-if="openCityDialog" :open.sync="openCityDialog" :company="company" :zone.sync="optionData")
        store-pickup-settings(v-if="showUpdateStorePickupSettings" :open.sync="showUpdateStorePickupSettings" :company.sync="company")
        y-dialog(v-model="openDeleteDialog" max-width='290' persistent)
          v-card
            v-card-title.h6.basic800--text.px-4 {{ $t('delete_zone') }}
            v-card-text.p2.primary500--text.px-4 {{ $t('delete_zone_confirmation') }}
            v-card-actions
              v-spacer
              v-btn(color='white', text @click='openDeleteDialog = false')
                .button-Aa-small.primary400--text {{ $t('cancel') }}
              v-btn.mr-2(color='danger500' depressed height=32 @click='clickDelete' :loading="isLoading" dark)
                .button-AA-small.basic100--text {{ $t('delete_zone') }}
</template>

<script>
import { mapActions } from 'vuex'
import DeliveryChargeList from '@/components/dialogs/settings/DeliveryChargeList.vue'
import ZoneCityList from '@/components/dialogs/settings/ZoneCityList.vue'
import StorePickupSettings from '@/components/dialogs/settings/yezzashipping/StorePickupSettings.vue'

export default {
  name: 'UpdateDeliveryZone',
  components: { DeliveryChargeList, ZoneCityList, StorePickupSettings},
  props: ['open', 'company', 'option', 'couriers', 'allowDelete'],
  data: () => ({
    optionData: {
      id: null,
      name: null,
      pickup_address: null,
      shipping_methods: [],
      enabled: true
    },
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
    },
    openDeleteDialog: false,
    openCityDialog: false,
    showUpdateStorePickupSettings: false,
    pickup: {},
    storepickup: {}
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    if (this.option) {
      this.optionData = {...this.option, shipping_methods: []}
      this.option.shipping_methods.forEach(o => {
        if (o === 'easyparcel') {
          !this.couriers.easyparcel.enabled || this.optionData.shipping_methods.push(o)
        } else if (o === 'zepto') {
          !this.couriers.zepto.enabled || this.optionData.shipping_methods.push(o)
        } else if (o === 'lalamove') {
          !this.couriers.lalamove.enabled || this.optionData.shipping_methods.push(o)
        } else {
          this.optionData.shipping_methods.push(o)
        }
      })
    }
    this.fetchPickup()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getCourierName (courier) {
      if (courier.name == 'YezzaShipping') {
        if (courier.category === 'courier') {
          return `${this.$t('courier_by')} Yezza Shipping`
        } else if (courier.category === 'local-delivery') {
          return `${this.$t('local_delivery_by')} by Yezza Shipping`
        }
      }
      return courier.name
    },
    fetchPickup () {
      if (this.optionData.id) {
        this.$axios.get(`/shipping/settings/${this.company.slug}/manual_shippings/?&shipping_zone=${this.optionData.id}&pickup=true`)
          .then(resp => {
            if (resp.data.results.length > 0) {
              this.pickup = resp.data.results[0]
            }
          })
      }
      this.$axios.get(`/shipping/settings/${this.company.slug}/storepickup`)
        .then((response) => {
          this.storepickup = response.data
        }).catch(() => {})
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      if (this.optionData.id) {
        if (this.optionData.shipping_methods.length === 0) {
          this.showMessage(['error', this.$t('error_message.no_shipping_method')])
          this.isLoading = false
          return
        }
        this.axios.put(`/shipping/settings/${this.company.slug}/zones/${this.optionData.id}/`, this.optionData)
        .then(resp => {
          if (this.optionData.shipping_methods.includes('pickup') && !this.storepickup.enabled) {
            if (this.pickup.id) {
              this.$axios.patch(`/shipping/settings/${this.company.slug}/manual_shippings/${this.pickup.id}/`, this.pickup)
                .catch(()=>{})
            } else {
              let data = {
                description: "Pickup",
                fee: 0,
                cod: false,
                pickup: true,
                pay_at_shop: this.pickup.pay_at_shop,
                params: [],
                rate_type: 'flat',
                shipping_zone: this.optionData.id
              }
              this.$axios.post(`/shipping/settings/${this.company.slug}/manual_shippings/`, data)
                .catch(()=>{})
            }
          }
          this.showMessage(['success', this.$t('success_message.zone_successfully_updated')])
          this.$emit('edited', resp.data)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.axios.post(`/shipping/settings/${this.company.slug}/zones/`, this.optionData)
        .then(resp => {
          // console.log(resp)
          this.optionData = resp.data
          this.$emit('added')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clickDelete() {
      this.isLoading = true
      this.axios.delete(`/shipping/settings/${this.company.slug}/zones/${this.optionData.id}/`)
        .then(() => {
          this.$emit('added')
          this.showModal = false
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "add_new_zone": "Add New Zone",
    "update_zone": "Update Zone",
    "delete_zone": "Delete Zone",
    "zone": {
      "label": "Zone Name",
      "placeholder": "Write zone option here",
      "hint": "Example: Putrajaya, Peninsular Malaysia, Others"
    },
    "restrict_delivery_areas": "Restrict delivery areas",
    "supported_delivery_method": "Supported delivery methods",
    "delivery_self_pickup": "Self Pickup",
    "delivery_self_pickup_text": "Pickup details by zone is disabled. Manage your pickup details at shipping settings.",
    "manual_delivery": "Manual Delivery",
    "pickup_location_description": "Pickup location description",
    "pickup_location_placeholder": "Address / location / link of pickup point",
    "allow_pay_at_shop": "Allow Pay at Shop",
    "allow_pay_at_shop_text": "Customer can choose to skip payment during order submission",
    "courier_by": "Courier by",
    "local_delivery_by": "Local Delivery by",
    "delete_zone_confirmation": "Are you sure you want to delete this zone? This zone will be deleted permanently."
  },
  "id": {
    "add_new_zone": "Tambah Zona baru",
    "update_zone": "Perbarui Zona",
    "delete_zone": "Hapus Zona",
    "zone": {
      "label": "Nama Zona",
      "placeholder": "Tulis opsi zona di sini",
      "hint": "Example: DKI Jakarta, Kota Makassar"
    },
    "restrict_delivery_areas": "Batasi area pengiriman",
    "supported_delivery_method": "Metode pengiriman yang didukung",
    "delivery_self_pickup": "Penjemputan Sendiri",
    "delivery_self_pickup_text": "Detail pengambilan menurut zona dinonaktifkan. Kelola detail pengambilan kamu di setelan pengiriman.",
    "manual_delivery": "Pengiriman Manual",
    "pickup_location_description": "Rincian Lokasi Penjemputan Sendiri",
    "pickup_location_placeholder": "Alamat / lokasi / link penjemputan",
    "allow_pay_at_shop": "Ijinkan pembayaran di toko",
    "allow_pay_at_shop_text": "Pelanggan dapat memilih untuk melewati pembayaran selama pengiriman pesanan",
    "courier_by": "Kurir oleh",
    "local_delivery_by": "Pengiriman Lokal oleh",
    "delete_zone_confirmation": "Anda yakin ingin menghapus zona ini? Zona ini akan dihapus secara permanen."
  }
}
</i18n>
